/**
 * Created by eungkyu on 2016. 1. 14..
 */
window.vvGa = (function(window) {
    function init(id, data) {
        if (window.ga != null) {
            if (data)
                window.ga('set', data);
            return;
        }

        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

        // 2017-08-01(UTC)부터 3% 샘플링 적용 - @diego
        var sampleRate = ((new Date()).getTime() / 1000 < 1501545600) ? 100 : 3;
        const pbSampleRate = ((new Date()).getTime() / 1000 < 1526256000) ? 100 : 3

        window.ga('create', id, 'auto', { sampleRate: sampleRate });
        window.ga('create', 'UA-102265094-1', 'auto', 'prebidTracker', { sampleRate: pbSampleRate });

        // en Recommend Quiz slot 1 CTR check
        window.ga('create', 'UA-102265094-5', 'auto', 'RecommendQuiz')

        // AB TEST
        window.ga('create', 'UA-102265094-4', 'auto', 'ABTest');

        window.ga('require', 'displayfeatures');
        if (data)
            window.ga('set', data);

        sendDeferredEvents();
    }

    function sendPageView(data) {
        if (window.ga == null)
            return;

        if (data)
            window.ga('set', data);
        window.ga('send', 'pageview');
    }

    function sendEvent(category, action, label, value, data) {
        if (window.ga == null)
            return;

        window.ga('send', 'event', category, action, label, value, data);
    }

    function deferEvent(category, action, label, value, data) {
        if (window.ga == null)
            return;

        var deferredEvents = vvSessionStorage.get('deferredGaEvents') || [];
        deferredEvents.push({
            href: window.location.href,
            category: category,
            action: action,
            label: label,
            value: value,
            data: data
        });
        vvSessionStorage.set('deferredGaEvents', deferredEvents);
    }

    function sendSocial(socialNetwork, socialAction, socialTarget) {
        if (window.ga == null)
            return;

        ga('send', {
            hitType: 'social',
            socialNetwork: socialNetwork,
            socialAction: socialAction,
            socialTarget: socialTarget
        });
    }

    function sendDeferredEvents() {
        if (window.ga == null)
            return;

        var deferredEvents = vvSessionStorage.getAndRemove('deferredGaEvents') || [];
        deferredEvents.forEach(function(event) {
            var parser = vv.parseUrl(event.href);
            window.ga('set', 'page', parser.pathname);
            window.ga('send', 'event', event.category, event.action, event.label, event.value, event.data);
        });
        window.ga('set', 'page', window.location.pathname);
    }

    // en Recommend Quiz slot 1 CTR check
    function sendRecommendEvent(category, action) {
        if (window.ga == null)
            return;

        window.ga('RecommendQuiz.send', 'event', category, action)
    }


    // AB TEST - no sampling
    function sendEventABTest(category, action, label) {
      if (window.ga == null)
        return;
      if (label) {
        window.ga('ABTest.send', 'event', category, action, label)
      } else {
        window.ga('ABTest.send', 'event', category, action)
      }
    }

    return {
        init: init,
        sendPageView: sendPageView,
        sendEvent: sendEvent,
        sendSocial: sendSocial,
        deferEvent: deferEvent,
        sendRecommendEvent: sendRecommendEvent,
        sendEventABTest: sendEventABTest,
    };
})(window);

window.vvTrack = (function(window) {
    var campaign = null;

    function loadCampaign() {
        var campaignParamMap = {
            utm_source: 'source',
            utm_medium: 'medium',
            utm_term: 'term',
            utm_content: 'content',
            utm_campaign: 'name',
            affiliate_code: 'affiliate',    // for Adx targeting
            grt_origin: 'origin',
            utm_id: 'utm_id'
        };

        campaign = {};

        var search = vv.parseQuery(window.location.search);
        Object.keys(campaignParamMap).forEach(function(key) {
            if (search[key])
                campaign[campaignParamMap[key]] = search[key];
        });

        if (Object.keys(campaign).length == 0)
            campaign = vvSessionStorage.get('utm') || {};
        vvSessionStorage.set('utm', campaign);
    }

    function getCampaign() {
        if (campaign == null)
            loadCampaign();

        return campaign;
    }

    function setGrtOrigin(origin) {
        if (campaign == null)
            loadCampaign();
        if (origin && campaign['origin'] !== origin) {
            campaign['origin'] = origin;
            vvSessionStorage.set('utm', campaign);
        }
    }

    function replaceUtmParams(url, name, source, medium, term, content) {
        var parser = vv.parseUrl(url);
        var search = vv.parseQuery(parser.search);
        if (name)
            search.utm_campaign = name;
        else
            delete search.utm_campaign;

        if (source)
            search.utm_source = source;
        else
            delete search.utm_source;

        if (medium)
            search.utm_medium = medium;
        else
            delete search.utm_medium;

        if (term)
            search.utm_term = term;
        else
            delete search.utm_term;

        if (content)
            search.utm_content = source;
        else
            delete search.utm_content;

        parser.search = vv.buildSearch(search);
        return parser.href;
    }

    function trackPageView(path, title) {
        title = title || vv.getMetaData('og:title');
        path = (path || window.location.pathname).replace(/^(\/quiz\/[rs]g?\/\d+\/\d+)\/?.+$/, '$1');
        var url = vv.getOrigin() + path;
        var hostname = window.location.hostname;

        // Google Analytics
        vvGa.sendPageView({
            hostname: hostname,
            page: path,
            title: title
        });

        // Baidu Tongji
        if (typeof(window._hmt) == 'object') {
            _hmt.push(['_trackPageview', path]);
        }
    }

    function trackFBPixel(what, params) {
        if (typeof(window.fbq) == 'function') {
            fbq('track', what, params);
        }
    }

    function trackTWPixel(what, params) {
        if (typeof(window.twq) == 'function') {
            twq('track', what);
        }
    }

    return {
        loadCampaign: loadCampaign,
        getCampaign: getCampaign,
        replaceUtmParams: replaceUtmParams,
        trackPageView: trackPageView,
        trackFBPixel: trackFBPixel,
        trackTWPixel: trackTWPixel,
        setGrtOrigin: setGrtOrigin,
    };
})(window);
